const arrendamientoResiduales = {
  path: "residuales",
  name: "residuales",
  component: () =>
    import(
      /* webpackChunkName: 'Dashboard-Residuales-Root' */ "@/modules/dashboard/pages/residuales"
    ),
};

export default arrendamientoResiduales;
